import React from 'react';

const AppContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="flex flex-col">{children}</div>;
};

export default AppContent;
